import {Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {ActionService} from "../services/action.service";
import {Subject, takeUntil} from "rxjs";

@Directive({
  selector: '[appHasPermission]'
})
export class HasPermissionDirective implements OnInit, OnDestroy {

  private requiredPermission: string = '';
  private hasView = false;
  private destroy$ = new Subject<void>();

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private actionService: ActionService) {
  }

  ngOnInit() {
    this.actionService.actionsLoaded$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((loaded) => {
      this.updateView()
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @Input()
  set appHasPermission(actionName: string) {
    this.requiredPermission = actionName;

    if (this.actionService.areActionLoaded)
      this.updateView();
  }

  private updateView(): void {
    const hasPermission = this.actionService.can(this.requiredPermission);

    if (hasPermission && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasPermission && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }


}
